module.exports = __webpack_public_path__ + "static/media/silkycloud-gold-4.99731d72.png";